import styled from 'styled-components';
import { COLORS } from '../../constants/radar';

export const Container = styled.div`
  padding: 24px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h1`
  color: ${COLORS.PRIMARY};
  font-size: 24px;
  margin: 0;
  font-weight: 600;
  position: relative;
  padding-left: 16px;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    width: 4px;
    background-color: ${COLORS.PRIMARY};
    border-radius: 2px;
  }
`;

export const HeaderButton = styled.button`
  padding: 8px 16px;
  background-color: white;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  white-space: nowrap;
  
  &:hover {
    background-color: ${COLORS.PRIMARY};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: scale(1.1);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: calc(100vh - 150px);
  overflow: hidden;
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: white;
  padding: ${props => props.show ? '16px' : '0'};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  opacity: ${props => props.show ? 1 : 0};
  max-height: ${props => props.show ? '300px' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  transform-origin: top;
  transform: ${props => props.show ? 'scaleY(1)' : 'scaleY(0)'};
  margin-bottom: ${props => props.show ? '0' : '0'};

  .MuiOutlinedInput-root {
    height: 40px;
    font-size: 14px;
  }

  .MuiSelect-select {
    padding: 8px 12px;
  }

  .MuiInputLabel-root {
    transform: translate(12px, 8px) scale(1);
    font-size: 14px;
    
    &.Mui-focused,
    &.MuiFormLabel-filled {
      transform: translate(12px, -9px) scale(0.75);
    }
  }
`;

export const MainContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  padding-bottom: 32px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-top: 0;
  transition: all 0.3s ease;
  position: relative;
`;

export const CVGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
  width: 100%;
`;

export const CVCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  min-height: 160px;
  height: 100%;
  width: 100%;
  transition: all 0.2s;
  cursor: pointer;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;

  &:hover {
    background-color: #f1f3f5;
    border-color: #bdbdbd;
  }
`;

export const CVCardContent = styled.div`
  padding: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EmployeeName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
  margin-bottom: 2px;
`;

export const EmployeeRole = styled.div`
  font-size: 13px;
  color: #64748B;
  margin-bottom: 4px;
`;

export const ItalicText = styled.span`
  font-style: italic;
  color: #94a3b8;
`;

export const VirtualizedListContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: visible;
  padding-right: 5px;
  position: relative;
`;